var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBookSpaceHotlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 28.5H41.25V27H38.25V28.5H32.25V25.5H39C39.45 25.5 39.75 25.2 39.75 24.75V11.25C39.75 10.8 39.45 10.5 39 10.5H19.5C19.05 10.5 18.75 10.8 18.75 11.25V24.75C18.75 25.2 19.05 25.5 19.5 25.5H26.25V28.5H15.75V26.25C15.75 25.8 15.45 25.5 15 25.5H14.25V24H15C15.45 24 15.75 23.7 15.75 23.25V20.25C15.75 19.8 15.45 19.5 15 19.5H5.25C4.8 19.5 4.5 19.8 4.5 20.25V22.5H3.75C3.3 22.5 3 22.8 3 23.25V26.25C3 26.7 3.3 27 3.75 27H4.5V28.5H0.75C0.3 28.5 0 28.8 0 29.25V33V45H1.5V33.75H3V45H4.5V33.75H40.5V45H42V33.75H43.5V45H45V33V29.25C45 28.8 44.7 28.5 44.25 28.5ZM38.25 12V20.25H20.25V12H38.25ZM20.25 21.75H38.25V24H31.5H27H20.25V21.75ZM27.75 25.5H30.75V28.5H27.75V25.5ZM6 21H14.25V22.5H13.5H6V21ZM4.5 24H5.25H12.75V25.5H5.25H4.5V24ZM6 27H13.5H14.25V28.5H6V27ZM41.25 32.25H3.75H1.5V30H5.25H15H27H31.5H43.5V32.25H41.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5H15C15.45 13.5 15.75 13.2 15.75 12.75V8.25C15.75 6.6 14.4 5.25 12.75 5.25H10.5V0H9V5.25H6.75C5.1 5.25 3.75 6.6 3.75 8.25V12.75C3.75 13.2 4.05 13.5 4.5 13.5ZM6.75 6.75H12.75C13.575 6.75 14.25 7.425 14.25 8.25V12H5.25V10.5H9V9H5.25V8.25C5.25 7.425 5.925 6.75 6.75 6.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBookSpaceHotlink);
export default __webpack_public_path__ + "static/media/dashboard-book-space-hotlink.ce4fbc886a5f75a372ef9acf44663422.svg";
export { ForwardRef as ReactComponent };